import React, { Component } from 'react';
import { Button } from "react-bootstrap";
import AboutModal from "./AboutModal";
import Autosuggest from 'react-autosuggest';
import "./App.css";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      driver1: "Daniil Kvyat",
      driver1suggestions: [],
      driver2: "Sebastian Vettel",
      driver2suggestions: [],
      drivers: require('./drivers.json'),
      path: null,
      message: "Press Go!",
      submessage: ""
    }
  }

  componentDidMount() {
    var graph = new this.Graph();
    var data = require('./data.json');

    for (var year in data) {
      for (var driver in data[year]) {
        graph.addEdge(driver, data[year][driver]);
      }
    }

    this.setState({
      graph: graph
    });
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleClear = event => {
    this.setState({
      driver1: "",
      driver2: "",
      path: null,
      message: "Cleared",
      submessage: "Enter two drivers and press Go."
    })
  }

  handleSwitch = event => {
    var driver1tmp = this.state.driver1
    var driver2tmp = this.state.driver2
    this.setState({
      driver1: driver2tmp,
      driver2: driver1tmp
    })
  }

  driverLookup(driver) {
    return this.state.drivers.includes(driver);
  }

  handleCalculate = event => {
    if (this.driverLookup(this.state.driver1) && this.driverLookup(this.state.driver2)) {
      var path = this.shortestPath(this.state.graph, this.state.driver1, this.state.driver2);
      if (path) {
        this.setState({
          path: path
        });
      } else {
        this.setState({
          path: null,
          message: "No, sorry!",
          submessage: "We couldn't find a link between these two drivers."
        });
      }
    } else {
      this.setState({
        path: null,
        message: "Error",
        submessage: "Enter the names of two drivers. Use the drop-down list to help."
      });
    }
  }

  year(driver1, driver2) {
    var data = require('./data.json');
    for (var year in data) {
      for (var driver in data[year]) {
        if (data[year][driver1] == driver2) {
          return year;
        }
      }
    }
  }

  getSuggestions = value => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    if (inputLength === 0) {
      return []
    }

    var filtered = this.state.drivers.filter(driver =>
      driver.toLowerCase().includes(inputValue)
    );

    if (filtered.length > 5) {
      return filtered.slice(0, 6);
    }

    return filtered;
  };


  // Just return the driver. No JSON navigation necessary.
  getSuggestionValue = d => d;

  // Just render the suggestion.
  renderSuggestion = suggestion => (<span>{suggestion}</span>);

  // Get suggestions for driver 1.
  getDriver1Suggestions = ({ value }) => {
    this.setState({ driver1suggestions: this.getSuggestions(value) });
  };

  // Get suggestions for driver 2.
  getDriver2Suggestions = ({ value }) => {
    this.setState({ driver2suggestions: this.getSuggestions(value) });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      driver1suggestions: []
    });
  };

  onDriver1Change = (event, { newValue }) => { this.setState({ driver1: newValue }); };
  onDriver2Change = (event, { newValue }) => { this.setState({ driver2: newValue }); };

  render() {
    var driver1Props = { placeholder: '', value: this.state.driver1, onChange: this.onDriver1Change, spellCheck: false };
    var driver2Props = { placeholder: '', value: this.state.driver2, onChange: this.onDriver2Change, spellCheck: false };

    return (
      <div>
        <div className="info"><AboutModal /></div>
        <div className="App container">
          <div className="logo">
            <div className="chevron">></div>
            <div className="text-container">
              <div className="transistive">Transitive</div>
              <div className="teammate">Teammate</div>
              <div className="comparisons">Comparisons</div>
            </div>
          </div>



          <div className="inputs">
            <div className="text">is</div>
            <Autosuggest
              spellCheck="false"
              suggestions={this.state.driver1suggestions}
              onSuggestionsFetchRequested={this.getDriver1Suggestions}
              onSuggestionsClearRequested={this.onSuggestionsClearRequested}
              getSuggestionValue={this.getSuggestionValue}
              renderSuggestion={this.renderSuggestion}
              inputProps={driver1Props}
            />
            <div className="text">better than</div>
            <Autosuggest
              spellCheck="false"
              suggestions={this.state.driver2suggestions}
              onSuggestionsFetchRequested={this.getDriver2Suggestions}
              onSuggestionsClearRequested={this.onSuggestionsClearRequested}
              getSuggestionValue={this.getSuggestionValue}
              renderSuggestion={this.renderSuggestion}
              inputProps={driver2Props}
            />
            <div className="text">?</div>
          </div>

          <div className="buttons">
            <Button id="clear" onClick={this.handleClear}><i className="fas fa-times"></i>Clear</Button>
            <Button id="switch" onClick={this.handleSwitch}><i className="fas fa-exchange-alt"></i>Swap</Button>
            <Button id="calculate" onClick={this.handleCalculate}><i className="fas fa-chevron-right"></i>Go</Button>
          </div>

          <div className="result text-center">
            <div className="result-inner">
              {this.renderResults()}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderResults() {
    var path = this.state.path;
    var output_arr = []

    if (path) {
      output_arr.push(
        <div key={-1}>
          <div className="result-title">Yes!</div>
          <div className="result-subtitle">And here's why:</div>
        </div>
      )

      for (var i = 0; i < path.length - 1; i++) {
        var driver1 = path[i]
        var driver2 = path[i + 1]
        output_arr.push(
          <div className="result-row" key={i}>
            <div className="wrapper">
              <div className="row-item left"><div className="driver-left">{driver1}</div></div>
              <div className="row-item middle">
                <div className="beat">beat</div>
                <div className="year">in {this.year(driver1, driver2)}</div>
              </div>
              <div className="row-item right"><span className="driver-right">{driver2}</span></div>
            </div>
            <div className="arrow-down"></div>
          </div>

          // <div className="result-row" key={i}>
          //   <Media>
          //     <Media.Body>{driver1} beat {driver2}</Media.Body>
          //     <Media.Right><div>{this.year(driver1, driver2)}</div></Media.Right>
          //   </Media>
          //   <div className="arrow-down"></div>
          // </div>
        );
      }
      return output_arr;
    } else {
      return (
        <div>
          <div className="result-title-fail">{this.state.message}</div>
          <div className="result-subtitle">{this.state.submessage}</div>
        </div>
      )
    }
  }

  Graph() {
    var neighbors = this.neighbors = {};

    this.addEdge = function (u, v) {
      if (neighbors[u] === undefined) {
        neighbors[u] = [];
      }
      if (!neighbors[u].includes(v)) {
        neighbors[u].push(v);
      }
    };
    return this;
  }

  shortestPath(graph, source, target) {
    if (source == target) {
      return;
    }
    var queue = [source],
      visited = { source: true },
      predecessor = {},
      tail = 0;

    while (tail < queue.length) {
      var u = queue[tail++], neighbors = graph.neighbors[u];
      if (neighbors) {
        for (var i = 0; i < neighbors.length; ++i) {
          var v = neighbors[i];
          if (visited[v]) {
            continue;
          }
          visited[v] = true;
          if (v === target) {
            var path = [v];
            while (u !== source) {
              path.push(u);
              u = predecessor[u];
            }
            path.push(u);
            path.reverse();
            return (path);
          }
          predecessor[v] = u;
          queue.push(v);
        }
      }
    }
    return null;
  }
}

export default App;
